<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <form
            @submit.prevent="submit(updatedProductGroup)"
            :class="{ 'disabled-form': disabled }"
          >
            <div class="p-2">
              <div class="mb-3">
                <label class="form-label" for="name">Name</label>
                <input
                  id="name"
                  name="name"
                  placeholder="Enter Price Group Name"
                  type="text"
                  class="form-control"
                  v-model="updatedProductGroup.name"
                  :disabled="disabled"
                />
              </div>
              <div class="mb-3">
                <label class="form-label" for="name">Cost Price</label>
                <input
                  id="name"
                  name="name"
                  placeholder="Enter Cost Price"
                  type="text"
                  class="form-control"
                  v-model="updatedProductGroup.costPrice"
                  :disabled="disabled"
                />
              </div>
              <div class="mb-1">
                <PricePercentSuggestor
                  v-model="updatedProductGroup.sellingPrice"
                  :costPrice="updatedProductGroup.costPrice"
                  :percentageOptions="[]"
                  calcMethod="margin"
                  :disabled="disabled"
                  label="Selling Price"
                  placeholder="Enter Selling Price"
                />
              </div>
              <div class="mb-1">
                <PricePercentSuggestor
                  v-model="updatedProductGroup.suggestedRetailPrice"
                  :costPrice="updatedProductGroup.sellingPrice"
                  calcMethod="margin"
                  :disabled="disabled"
                  label="Suggested Retail Price"
                  placeholder="Enter Retail Price"
                />
              </div>
              <div class="hstack gap-2 mt-4">
                <button v-if="!disabled" type="submit" class="btn btn-primary">
                  Save
                </button>
                <button
                  v-if="disabled"
                  type="button"
                  class="btn btn-primary"
                  @click="edit"
                >
                  Edit
                </button>
                <button type="button" class="btn btn-light" @click="discard">
                  Back
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PricePercentSuggestor from "@/components/product/PricePercentSuggestor";
export default {
  name: "ProductGroupForm",
  components: { PricePercentSuggestor },
  props: {
    productGroup: {
      type: Object,
      required: true,
    },
    submitFunction: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      updatedProductGroup: { ...this.productGroup },
    };
  },
  methods: {
    submit() {
      if (!this.disabled) {
        this.submitFunction(this.updatedProductGroup);
      }
    },
    discard() {
      this.updatedProductGroup = { ...this.productGroup };
      this.$router.push("/productGroups/");
    },
    edit() {
      this.$router.push("/productGroups/edit/" + this.productGroup.id);
    },
  },
  computed: {
    disabled() {
      return typeof this.submitFunction !== "function";
    },
  },
};
</script>

<style scoped>
.disabled-form input {
  pointer-events: none;
  opacity: 0.6;
}
</style>
